import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const examinationSessionLocaleModule: LocaleModule = {
  name: "examinationSession",
  messages: { en: en, it: it },
};
